import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-banner-google-ads',
    templateUrl: './banner-google-ads.component.html',
    styleUrls: ['./banner-google-ads.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BannerGoogleAdsComponent implements OnInit {

  @Input() id_banner: string = '';
  @Input() id_slot: string = '';

  public checkDivFree = false;

  constructor( private utilities: UtilitiesService ) { }

  ngOnInit(): void {
    this.checkBannerFree()
  }

  checkBannerFree() {
    this.utilities.addAdsById(this.id_slot, this.id_banner, [[728, 90], [300, 50]])
	}

}
